<p-table
    #dt1
    [value]="dataSource ?? []"
    [lazy]="true" (onLazyLoad)="loadBrands($event)"
    [paginator]="true"
    [rows]="10"
    responsiveLayout="stack"
    breakpoint="960px"
    stripedRows
    [paginatorDropdownAppendTo]="'body'"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '20rem' }"
    [totalRecords]="totalRecords"
    [styleClass]="'p-datatable-sm border border-surface lg:border-none'"
    currentPageReportTemplate="{totalRecords} Markadan  {first} - {last} Gösteriliyor "
    [rowsPerPageOptions]="[10,25,50]"
    [globalFilterFields]="['customerName', 'number', 'message']"
>
    <ng-template #caption>
        <div class="flex gap-2">

      <p-inputgroup class="!w-auto" styleClass="!w-auto">
        <p-inputgroup-addon>
          <i class="pi pi-search"></i>
        </p-inputgroup-addon>

                <input pInputText type="text" #filter
                       class="w-56 lg:w-auto"
                       (input)="dt1.filterGlobal($any($event.target).value ?? '', 'contains')" placeholder="Arama..."/>
      </p-inputgroup>
            @if (request.SearchKey.length > 0) {

                <p-button
                  [outlined]="true"
                  label="Filtreyi Kaldır"
                        class="hidden lg:inline-flex justify-center "
                        icon="pi pi-filter-slash"
                        (click)="clear(dt1); filter.value =''"></p-button>
                <p-button
                  [outlined]="true"
                  class="inline-flex lg:hidden  justify-center  "
                        icon="pi pi-filter-slash"
                        (click)="clear(dt1); filter.value =''"></p-button>
            }

            <div class="ml-auto">

                <p-button
                  [outlined]="true"
                  label="Marka Yenile"
                        class="hidden lg:inline-flex justify-center "
                        icon="pi pi-refresh"
                        (click)="newRequest=true ; getBrands()"></p-button>
                <p-button  [outlined]="true"  class="inline-flex lg:hidden  justify-center "
                        icon="pi pi-refresh"
                        (click)="newRequest=true ; getBrands()"></p-button>
            </div>
        </div>
    </ng-template>
    <ng-template #header>
        <tr>
            <th style="width: 30%;">
                Kodu
            </th>
            <th style="width: 60%;">
                Marka Adı
            </th>
            <th style="width: 10%;">
                Seçim
            </th>
            <!--      <th pSortableColumn="customerName" style="width:25%">Ad Soyad <p-sortIcon field="customerName"></p-sortIcon></th>
                  <th pSortableColumn="number" style="width:25%">Sipariş Numarası<p-sortIcon field="number"></p-sortIcon></th>
                  <th pSortableColumn="status" style="width:25%">Durumu<p-sortIcon field="status"></p-sortIcon></th>
                  <th pSortableColumn="message" style="width:25%">Mesaj<p-sortIcon field="message"></p-sortIcon></th>-->
        </tr>
    </ng-template>
    <ng-template #body let-brand>
        <tr>
            <td>
                <span class="p-column-title font-bold">Kodu</span>
                {{ brand.Code }}
            </td>
            <td><span class="p-column-title font-bold">Marka Adı</span>
                {{ brand.Name }}
            </td>
            <td>

                <div class="flex justify-center lg:justify-start w-full">
                    <button pButton class="!w-full" icon="pi pi-check" (click)="ref.close(brand)" size="small"></button>
                </div>
                <!-- <div class="hover:text-primary cursor-pointer font-medium">Seç</div>
                <i class="pi pi-check hover:text-primary cursor-pointer  font-medium">Seç</i>-->
                <!--  <p-button icon="pi pi-check" [rounded]="true" [text]="true"></p-button>-->
            </td>
        </tr>
    </ng-template>
</p-table>
